/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPrescription } from 'app/shared/model/prescription.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IDiaglabAssistant } from 'app/shared/model/diaglab-assistant.model';
import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface ILabPrescription {
  id?: string;
  status?: string | null;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  otc?: boolean | null;
  orderStatus?: keyof typeof OrderStatus | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  prescription?: IPrescription;
  glucoUser?: IGlucoUser;
  servedBy?: IDiagLab | null;
  orderedBy?: IDoctor | null;
  appointment?: IAppointments | null;
  otcBy?: IDiaglabAssistant | null;
  treatmentPlan?: ITreatmentPlan | null;
  procedure?: IPatientProcedure | null;
}

export const defaultValue: Readonly<ILabPrescription> = {
  active: false,
  exposed: false,
  otc: false,
};
